import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/billing-systems/new/loading';

export const Route = createFileRoute('/_private/settings/billing-systems/new')({
  component: Loading,
});
